var Portfolio = Chaplin.Model.extend({

});

module.exports = Portfolio;
